import React, { useState, useEffect } from 'react';
import {forIn, isArray, isEmpty} from 'lodash';
import {JiraRelatedDetails, JiraRelatedSnip} from './Jira';
import {Box, Paragraph} from '../../../styled';

interface RelatedProps{
  data: any,
  type: string,
  headline?: string,
}

interface typeMappingProps{
  [key:string]: any,
}

const typeMapping:typeMappingProps = {
  jira: {
    snippet: JiraRelatedSnip,
    details: JiraRelatedDetails,
  }
}

export const Related = ({ data = {}, type, headline = 'Related to' }: RelatedProps) => {
  const shownItems = 3;
  const [showAll, setShowAll] = useState<Boolean>(type !== 'snippet');
  const [tickets, setTickets] = useState<Array<any>>([]);
  const [displayTickets, setDisplayTickets] = useState<Array<any>>([]);
  const [moreNumber, setMoreNumber] = useState(0);
  const showMore = (e:any) => {
    e.stopPropagation();
    setShowAll(!showAll);
  }

  useEffect(() => {
    if (isEmpty(data)) {
      return;
    }
    const elements:Array<any> = [];
    forIn(data, (value, k) => {
      if (!value || !typeMapping[k] || !typeMapping[k][type]) {
        return;
      }
      if (isArray(value)) {
        value.forEach((item) => {
          elements.push(React.createElement(typeMapping[k][type], { data: item, key: item.issue_key }))
        })
      } else {
        elements.push(React.createElement(typeMapping[k][type], { data: value }))
      }
    });
    setTickets(elements);
  }, [data, type]);
  useEffect(() => {
    if (showAll) {
      setDisplayTickets(tickets);
      return;
    }
    if (type === 'snippet' && !showAll) {
      setDisplayTickets(tickets.slice(0, shownItems));
      if (tickets.length > shownItems) {
        setMoreNumber(tickets.length - shownItems)
      }
    }
  }, [type, tickets, showAll]);

  if (isEmpty(data) || !type || !tickets.length) {
    return null;
  }

  return (
    <Box pl={type === 'details' ? '5px' : 0}>
      <Paragraph size={'sm'} weight={600} mb={0} color={'gray2'}>
        {headline}
      </Paragraph>
      <Box mb={2}>
        {displayTickets}
        {(moreNumber && type === 'snippet') ? (
          <Box
            border={'1px solid #bfcff2'}
            borderRadius={10}
            backgroundColor={'#fff'}
            color={'#828282'}
            display={'inline-block'}
            p={'7px 11px'}
            onClick={showMore}
          >
            {!showAll ? (
              <span>
                +{moreNumber} more
              </span>
            ) : (
              <span>
                Hide
              </span>
            )}
          </Box>
        ) : null}
      </Box>
    </Box>
  );
}